import PropTypes from 'prop-types';
import Push from '@/components/common/design-system/Push.ds';
import ProductAttributesTable from '@/components/product/ProductDetails/ProductAttributesTable';
import { IMG_SIZE } from '@/constants/urls';
import { buildImage, convertToWebPUrl, getProductImage } from '@/utils/productUtils';
import styles from './ProductDetailsDesktop.module.scss';

const ProductDetailsDesktop = ({ t, product, productInfo, productAndItemAttributes, attributesRef }) => {
	const image = product?.bonus?.length > 0 ? buildImage(product.bonus[0], IMG_SIZE.FULL) : getProductImage(product.image, false);

	return (
		<>
			{productInfo.longdesc?.length > 0 && (
				<div className={styles.container} data-rbf="product-details-desktop">
					<p className={styles.title} data-test-id="title">
						{t('product.description')}
					</p>
					<div className={styles.content}>
						<div
							className={styles.description}
							data-test-id="longdesc"
							dangerouslySetInnerHTML={{ __html: productInfo.longdesc }}
						/>
						<picture>
							<source srcSet={convertToWebPUrl(image)} type="image/webp" />
							<img src={image} alt={product.productName} height={531} loading="lazy" />
						</picture>
					</div>
				</div>
			)}
			{product.espotPush && <Push {...product.espotPush} />}
			<ProductAttributesTable attributes={productAndItemAttributes} attributesRef={attributesRef} showTitle />
		</>
	);
};

ProductDetailsDesktop.propTypes = {
	t: PropTypes.func.isRequired,
	product: PropTypes.object.isRequired,
	productInfo: PropTypes.object.isRequired,
	productAndItemAttributes: PropTypes.array,
	attributesRef: PropTypes.object,
};

export default ProductDetailsDesktop;
